﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'components/tooltip';


export function StringToEllipsesString(
    {
        length = 3,
        showTooltip = false,
        children
    }
) {
    if (!children) {
        return null;
    }

    //Ensure this is a string
    if (typeof children !== 'string') {
        return children;
    }

    return (showTooltip && children.length > length + 1 ? <Tooltip content={children}>{strToEllipsesLength(children, length)}</Tooltip> : strToEllipsesLength(children, length + 1));
}

function strToEllipsesLength(str, ellipseLength) {
    if (str.length > ellipseLength) {
        return <Fragment>{str.substring(0, ellipseLength)}&hellip;</Fragment>;
    }
    return str;
}

StringToEllipsesString.propTypes = {
    length: PropTypes.number,
    showTooltip: PropTypes.bool
};